import React, { useEffect, useState } from "react";
import "./CustomiseAllocation.scss";
import { TitleBar } from "../../../Global/TitleBar/TitleBar";
import { TopBar } from "../../TopBar/TopBar";
import { IoSearchSharp } from "react-icons/io5";
import {
  CreateButton,
  RedBordButton,
  ViewMoreButton,
} from "../../../Global/GlobalButton";
import { InputLabel, SelectBorder } from "../../../Global/GlobalFormElement";
import { GlobalTable } from "../../../Global/GlobalTable/GlobalTable";
import axios from "axios";
import { EXCHNAGE_URL } from "../../../../Url/Url";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { MdEditSquare } from "react-icons/md";
import { GlobalSecondTable } from "../../../Global/GlobalSecondTable/GlobalSecondTable";
import { GreenContent, RedContent } from "../../../Global/GlobalText";

export const CustomiseAllocation = () => {
  // const [selectedRow, setSelectedRow] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);

  const [newData, setNewData] = useState([])
  const [roundData, setRoundData] = useState([]);
  const [allocation, setAllocation] = useState('');
  const [selectedRound, setSelectedRound] = useState(null);
  const [roundId, setRoundId] = useState(null);
  const [roundName, setRoundName] = useState("");
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const [juryData, setJuryData] = useState([]);
  const [juryId, setJuryId] = useState([]);
  const [selectedJury, setSelectedJury] = useState([]);
  const [selectedJuryData, setSelectedJuryData] = useState([])
  const [selectedJuryEmail, setSelectedJuryEmail] = useState([])

  const eventIdGet = useSelector((state) => state?.users?.id);
  const eventId = String(eventIdGet);

  const token = localStorage.getItem("token")



  useEffect(() => {
    const fetchRounds = async () => {
      try {
        const response = await axios.get(`${EXCHNAGE_URL}/listOfRounds?eventId=${eventId}`, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        });
        const roundData = response.data.data;
        setRoundData(roundData);
      } catch (error) {
        console.log(error);
      }
    };
    fetchRounds();
  }, [eventId, token]);

  const handleRoundClick = (round) => {
    setSelectedRound(round);
    toast.success("Round selected Successfully")
    setRoundId(round.roundId);
    setRoundName(round.round_name)
    setIsDropdownVisible(false);

  };

  const handleJuryChange = (event) => {
    const selectedEmail = event.target.value;
    const selectedJuryData = juryData.find((jury) => jury.email === selectedEmail);
    console.log(selectedJuryData, "juryId");

    if (selectedJuryData) {
      setSelectedJury(selectedEmail);
      setJuryId(selectedJuryData.juryAssignId);
      setSelectedJuryEmail(selectedJuryData.email);
      toast.success("Jury Selected Successfully");
    }
  };

  console.log(juryId, "juryId");


  useEffect(() => {
    if (roundId) {
      const fetchAllJuryAssignment = async () => {
        try {
          const response = await axios.get(`${EXCHNAGE_URL}/allAssignJury?eventId=${eventId}&roundId=${roundId}`, {
            headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json'
            }
          });
          const allJuryData = response.data.data;
          setJuryData(allJuryData);
        } catch (error) {
          console.log(error);
        }
      };
      fetchAllJuryAssignment();
    }
  }, [roundId, eventId, token]);

  const getCustomiseAllocation = async () => {
    try {
      const response = await axios.get(
        `${EXCHNAGE_URL}/getCustomAllocation?eventId=${eventId}&roundId=${roundId}&juryAssignId=${juryId}&email=${selectedJuryEmail}`, {
        headers: {
          "Content-Type": "Application/json",
          authorization: `Bearer ${token}`
        },
      }
      );
      if (response.status === 200) {
        toast.success("Customized Allocated Data fetched Successfully.")
        console.log(response.data.data, "123");
        setSelectedJuryData(response.data.data)
      }
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    getCustomiseAllocation()
  }, [eventId, roundId, juryId, token])

  const mapJuryData = (selectedJuryData) => {
    return selectedJuryData.map((juryNew) => {
      const title = juryNew.title || "";
      const category = juryNew.category || "";
      const email = juryNew.email || "No Email";
      return {
        rowId: juryNew.submission_id,
        "Submission ID": juryNew.submission_id,
        Category: category,
        Title: title,
        Status: juryNew.allocation,
        "Submitted by Username": email,
      };
    });
  };

  useEffect(() => {
    if (selectedJuryData.length > 0) {
      const formattedJuryData = mapJuryData(selectedJuryData);
      setNewData(formattedJuryData);
    }
  }, [selectedJuryData]);


  const columns = [
    { label: "Submission ID", accessor: "Submission ID" },
    { label: "Title", accessor: "Title" },
    { label: "Submitted by Username", accessor: "Submitted by Username" },
    { label: "Category", accessor: "Category" },
    { label: "Status", accessor: "Status" },
  ];

  const setSelectedRow = (row) => {
    console.log("Selected row:", row);
  };


  const handleCheckboxChange = (rowId, checked) => {
    const selectedRow = newData.find((row) => row.rowId === rowId);
    if (checked) {
      setSelectedRows((prevSelectedRows) => [...prevSelectedRows, selectedRow.rowId]);
    } else {
      setSelectedRows((prevSelectedRows) =>
        prevSelectedRows.filter((id) => id !== selectedRow.rowId)
      );
    }
  };
  console.log("ids", selectedRows)

  const prepareDataForApi = () => {
    return {
      eventId: eventId,
      roundId: roundId,
      juryAssignId: juryId,
      email: selectedJury,
      submission_ids: selectedRows,
      allocation: allocation,
    };
  };
  const sendDataToApi = async () => {
    try {
      const requestData = prepareDataForApi(); // Prepare the data to be sent to the API
      const response = await axios.post(
        `${EXCHNAGE_URL}/customAllocation`, // Replace with the actual endpoint URL
        requestData,
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
        }
      );

      if (response.status === 200) {
        toast.success("Allocation updated successfully");
        getCustomiseAllocation()
      } else {
        toast.error("Failed to update allocation");
      }
    } catch (error) {
      console.error("Error updating allocation:", error);
      toast.error("An error occurred while updating allocation");
    }
  };
  const handleAbstainClick = () => {
    setAllocation('abstain');
  };

  const handleNonAbstainClick = () => {
    setAllocation('non-abstain');
  };

  useEffect(() => {
    if (allocation) {
      sendDataToApi();
    }
  }, [allocation]);

  return (
    <div>
      <div className="custom_allocation_data_div">
        <TitleBar title="Customise Allocation" />

        <div className="custom_allocation_white_bg">
          <TopBar titleheading="Customise Allocation" />
          <div className="newBtn">

            <div>
              <button
                className="Bt"
                onClick={() => setIsDropdownVisible(!isDropdownVisible)}>
                {isDropdownVisible ? 'Hide Rounds' : 'Show Rounds'}
              </button>

              {isDropdownVisible && (
                <div
                  className={`dropdown-container ${isDropdownVisible ? "show" : ""}`}
                >
                  {roundData.length !== 0 ? (
                    roundData.map((round, index) => (
                      <div
                        key={round.roundId}
                        className="round-button-container"
                        style={{ marginBottom: '1rem' }}
                      >
                        <CreateButton className="Btt" onClick={() => handleRoundClick(round)}>
                          {round.round_name}
                        </CreateButton>
                        {round.is_active === 1 ? (
                          <GreenContent>Active</GreenContent>
                        ) : (
                          <RedContent>Unactive</RedContent>
                        )}                        </div>
                    ))
                  ) : (
                    <div>No rounds available</div>
                  )}
                </div>
              )}
            </div>

            {selectedRound && (
              <div className="round-details">
                <CreateButton>
                  {selectedRound.round_name} 
                </CreateButton>
                {/* <GreenContent>Active</GreenContent> */}
              </div>
            )}
          </div>
          <div className="custom_allocation_select">
            <InputLabel>
              Jury Name <span style={{ color: "#C32728" }}>*</span>{" "}
            </InputLabel>
            <SelectBorder onChange={handleJuryChange} value={selectedJury} >
              <option value="Select An Option ">Select An Option</option>
              {juryData.map((jury) => (
                <option key={jury.juryAssignId} value={jury.email}>
                  {jury.email}
                </option>
              ))}
            </SelectBorder>
          </div>

          <div className="custom_allocation_table_div">

            <div className="custom_allocation_table_search">
              <div className="custom_allocation_table_icon">
                <IoSearchSharp />
              </div>
              <div className="custom_allocation_table_icon_content">
                <input type="text" placeholder="Search here..." />
              </div>
            </div>

            <div className="custom_allocation_filter_btn">
              <CreateButton
                onClick={() => window.location.reload()}
              >Refresh</CreateButton>

              <ViewMoreButton onClick={handleAbstainClick} style={{ color: "#333333" }}>
                Abstain
              </ViewMoreButton>

              <RedBordButton onClick={handleNonAbstainClick} style={{ fontSize: "16px" }}>
                Non-Abstain
              </RedBordButton>
            </div>

          </div>

          <GlobalSecondTable
            data={newData}
            columns={columns}
            onRowClick={setSelectedRow}
            selectedRows={selectedRows} // Ensure this is always an array

            onCheckboxChange={handleCheckboxChange}

          />
        </div>
      </div>
    </div>
  );
};
